// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hm-0";